<template>
  <AlCard id="monthly-tabs" v-featureflow:isOn="'capacity-planner-scenarios'">
    <AlTabs :tabs="tabs" @tab-active="selectTab" :defaultTab="0" />
    <router-view class="monthly-tab-body" @change="onChange"></router-view>
  </AlCard>
</template>

<script>
import { AlTabs, AlCard } from "@playvox/almendra-components";

import { Translator } from "@agyletime/wfm-vue-common";

export default {
  components: {
    AlTabs,
    AlCard,
  },
  mixins: [Translator],
  data() {
    return {
      tabs: [],
    };
  },
  created() {
    this.tabs = [
      {
        label: this.translate("plan-overview-leave-tab-title"),
        name: "leave",
        to: "/view/:id/details/:month/leave",
        active: true,
      },
      {
        label: "Shrinkage",
        name: "shrinkage",
        to: "/view/:id/details/:month/shrinkage",
      },
    ];
  },
  methods: {
    selectTab(tab) {
      if (tab.name !== this.$router.currentRoute.name) {
        this.$router.push({
          name: tab.name,
          params: {
            ...this.$router.currentRoute.params,
          },
        });
      }
    },
    featureEnabled(key) {
      return window.PlayvoxWFM.featureflow.evaluate(key).isOn();
    },
    onChange(data) {
      this.$emit("change", data);
    },
  },
};
</script>

<style lang="scss">
#monthly-tabs {
  padding: 0;
  position: relative;
  overflow: visible;

  .dr-tabs-list {
    padding-left: 32px;
  }
  .monthly-tab-body {
    padding: 48px;
    min-height: 20rem;
  }
  .edit-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;

    & > * {
      margin-right: 0.5rem;
      margin-top: 0.5rem;
    }
  }

  .message {
    display: none;
  }

  .row-data {
    min-height: 44px;
  }

  .edit-row .decimal-input-field {
    width: auto;
  }

  .dr-input__append:not(.dr-input--sm *) {
    padding: 0px;
    height: 42px;
  }

  .dr-input__input:not(.dr-input--sm *) {
    padding: 9px 9px 9px;
  }

  .decimal-input-field .append {
    font-size: 0.8em;
    line-height: 20px;
  }

  .multiselect.dr-multiselect .multiselect__tags {
    width: 15rem;
  }
  .edit-actions {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;

    & > * {
      margin-right: 0.5rem;
    }
  }

  @media screen and (max-width: 899px) {
    .edit-row > * {
      min-width: 40%;
    }
  }
  @media screen and (max-width: 699px) {
    .edit-row > * {
      min-width: 100%;
    }
    .edit-actions {
      margin-top: 1rem;
      justify-content: flex-start;
    }
  }
}
</style>
